<form [formGroup]="myWOFormGroup">
  <div class="aems-card m-b-12">
    <div class="pure-g m-b-12" style="gap: 6px">
      <div class="pure-u-md-5-24 pure-u-lg-4-24 pure-u-xl-4-24 pure-u-xxl-3-24 pure-u-xxxl-3-24 pure-u-x4k-3-24">
        <mc-select
          label="Queue"
          fit="small"
          placeholder="Select an option"
          ngDefaultControl
          formControlName="queue"
          (optionselected)="onQueueSelect($event)">
          @for (queue of queueList; track queue) {
            <mc-option [attr.data-cy]="queue.queue" [value]="queue">{{ queue.queue }}</mc-option>
          }
        </mc-select>
      </div>
      <div class="pure-u-md-5-24 pure-u-lg-4-24 pure-u-xl-4-24 pure-u-xxl-3-24 pure-u-xxxl-3-24 pure-u-x4k-3-24">
        <mc-select
          label="Region"
          fit="small"
          placeholder="Select an option"
          ngDefaultControl
          formControlName="region"
          (optionselected)="onRegionSelected($event)">
          @for (loc of regions; track loc) {
            <mc-option [attr.data-cy]="loc.code" [value]="loc.name"> {{ loc.name }}</mc-option>
          }
        </mc-select>
      </div>
      <div class="pure-u-md-5-24 pure-u-lg-4-24 pure-u-xl-4-24 pure-u-xxl-3-24 pure-u-xxxl-3-24 pure-u-x4k-3-24">
        <mc-typeahead
          highlight="true"
          showlistonfocus="true"
          maxoptions="20"
          optionsheight="500px"
          optionswidth="200px"
          ngDefaultControl
          label="Cluster"
          placeholder="Type to search"
          fit="small"
          formControlName="countrycluster"
          [data]="clusters"
          (optionselected)="onClusterSelected($event)"
          (search)="onClusterSearch($event)"
          oninput="this.value = this.value.toUpperCase()">
        </mc-typeahead>
      </div>
      <div class="pure-u-md-5-24 pure-u-lg-4-24 pure-u-xl-4-24 pure-u-xxl-3-24 pure-u-xxxl-3-24 pure-u-x4k-3-24">
        <mc-typeahead
          highlight="true"
          showlistonfocus="true"
          maxoptions="100"
          optionsheight="500px"
          optionswidth="200px"
          ngDefaultControl
          label="Country(Optional)"
          (optionselected)="onCountrySelected($event)"
          placeholder="Type to search"
          fit="small"
          formControlName="shopCountry"
          [data]="countries"
          oninput="this.value = this.value.toUpperCase()">
        </mc-typeahead>
      </div>
      <div class="pure-u-md-5-24 pure-u-lg-4-24 pure-u-xl-4-24 pure-u-xxl-3-24 pure-u-xxxl-3-24 pure-u-x4k-3-24">
        <mc-typeahead
          highlight="true"
          showlistonfocus="true"
          maxoptions="100"
          optionsheight="500px"
          optionswidth="200px"
          ngDefaultControl
          label="Shop Code(Optional)"
          (optionselected)="onShopSelected($event)"
          placeholder="Type to search"
          fit="small"
          formControlName="shopCode"
          [data]="shopCodes"
          oninput="this.value = this.value.toUpperCase()">
        </mc-typeahead>
      </div>
      <div class="pure-u-md-5-24 pure-u-lg-4-24 pure-u-xl-4-24 pure-u-xxl-3-24 pure-u-xxxl-3-24 pure-u-x4k-3-24">
        <mc-multi-select
          label="Mode(Optional)"
          fit="small"
          width="100"
          placeholder="Select an option"
          ngDefaultControl
          formControlName="mode"
          (optionselected)="onModeSelected($event)">
          @for (mode of modes; track mode.repairMode) {
            <mc-option [attr.data-cy]="mode.repairMode" [value]="mode.repairMode"
              >{{ mode.repairMode }} {{ mode.modeDescription }}
            </mc-option>
          }
        </mc-multi-select>
      </div>
    </div>
    <!-- Second row with search fields and button -->
    <div class="pure-g" style="gap: 6px; align-items: baseline">
      <div class="pure-u-md-11-24">
        <app-aems-multiline-tag-input
          label="Search by Work Order"
          placeholder="Enter Work Order Number"
          [regex]="workOrderRegex"
          formControlName="workOrderSearch"
          [heightInPixels]="70"
          [allowDuplicates]="false"
          [transformToUppercase]="true">
        </app-aems-multiline-tag-input>
      </div>
      <div class="pure-u-md-11-24">
        <app-aems-multiline-tag-input
          label="Search by Equipment"
          placeholder="Enter Equipment Number"
          [regex]="equipmentRegex"
          formControlName="equipmentSearch"
          [heightInPixels]="70"
          [allowDuplicates]="false"
          [transformToUppercase]="true">
        </app-aems-multiline-tag-input>
      </div>
    </div>
    <div class="pure-g m-t-12">
      <div class="pure-u-md-7-24">
        <mc-button
          label="Assign work orders"
          slot="primaryAction"
          variant="filled"
          appearance="primary"
          fit="medium"
          [disabled]="!isAssignButtonEnabled"
          (click)="assignWO()"
          (keydown.enter)="assignWO()"
          (keydown.space)="assignWO()"></mc-button>
      </div>
      <div class="pure-u-md-7-24">
        <mc-button
          label="Unassign work orders"
          slot="primaryAction"
          variant="filled"
          appearance="primary"
          fit="medium"
          [disabled]="!isUnassignButtonEnabled"
          (click)="unassignWO()"
          (keydown.enter)="unassignWO()"
          (keydown.space)="unassignWO()"></mc-button>
      </div>
    </div>
  </div>
</form>

@if (loadGrid && data.length > 0) {
  <app-approval-my-wo-grid [data]="data"></app-approval-my-wo-grid>
} @else if (loadGrid && data.length === 0) {
  <div class="aems-card no-data">
    <p>All your assigned work orders will be displayed here</p>
  </div>
}
